/********************************************
* Log browser version on non-production environments
********************************************/

function fnShowBrowserVersion() {

    var sDomainName = window.location.hostname;

    if( sDomainName.search( ".local" ) >= 1 || sDomainName.search( ".flywheelsites" )  >= 1 ) {

        navigator.sayswho= ( function() {
            var ua= navigator.userAgent, tem,
            M= ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
            if(/trident/i.test(M[1])){
                tem=  /\brv[ :]+(\d+)/g.exec(ua) || [];
                return 'IE '+(tem[1] || '');
            }
            if(M[1]=== 'Chrome'){
                tem= ua.match(/\b(OPR|Edge)\/(\d+)/);
                if(tem!= null) return tem.slice(1).join(' ').replace('OPR', 'Opera');
            }
            M= M[2]? [M[1], M[2]]: [navigator.appName, navigator.appVersion, '-?'];
            if((tem= ua.match(/version\/(\d+)/i))!= null) M.splice(1, 1, tem[1]);
            return M.join(' ');
        })();

        console.log( "BROWSER : " + navigator.sayswho ); // outputs: `Chrome 62`

    }

}


// END OF DOCUMENT
